import { fetcher } from "helpers/fetcher";

import { TUpdateTagReq, TUpdateTagRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateTag = async (payload: TUpdateTagReq) => {
  return await fetcher<TUpdateTagRes, TUpdateTagReq["data"]>(
    ENDPOINT.MANAGEMENT.UPDATE_TAG,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.UPDATE_TAG.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationUpdateTag = async (payload: TUpdateTagReq) => {
  return (await updateTag(payload)).data.message;
};

mutationUpdateTag._key = (payload: TUpdateTagReq) => [
  ENDPOINT.MANAGEMENT.UPDATE_TAG.url,
  payload,
];
